@if (dateOfBirth) {@if(showParenthesis){(}{{
  dateOfBirth | age
}}@if(showParenthesis){)} }
